module.exports = __webpack_public_path__ + "img/OGG_Background_Red.0e35ec60.png";